"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _BreadcrumbItem = _interopRequireDefault(require("./_BreadcrumbItem"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _breadcrumb = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/breadcrumb.css") : void 0);

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _breadcrumb.default);
/** A **Breadcrumb** allows users to see the current page and navigation path to that page.
 * Users can navigate to previous levels in the path. When clicking on the current page,
 * a dropdown allows users to access other pages at that same level. */

var Breadcrumb = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      cssNamespace = _ref.cssNamespace,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children", "cssNamespace"]);
  return /*#__PURE__*/_react.default.createElement("ul", (0, _extends2.default)({}, props, {
    className: classnames("".concat(cssNamespace, "-breadcrumb")),
    ref: ref,
    role: "menu"
  }), children);
});

Breadcrumb.displayName = 'Breadcrumb';
Breadcrumb.propTypes = {
  /** List item (`Breadcrumb.Item`) nodes or React Router Link components */
  children: _propTypes.default.node
};
Breadcrumb.Item = _BreadcrumbItem.default;

var _default = (0, _withStyles.default)(Breadcrumb);

exports.default = _default;